export const MIXPANEL_EXPERIMENT_STARTED_EVENT_NAME = "$experiment_started";
export const MIXPANEL_EXPERIMENT_NAME_PROPERTY = "Experiment name";
export const MIXPANEL_VARIANT_NAME_PROPERTY = "Variant name";
